import 'bootstrap/js/dist/collapse';

import Swal from 'sweetalert2';

(function($) {

	// Add sweetalert2 to Contact Form 7 messages
	document.addEventListener('wpcf7submit', function(event) {

		if (event.detail.status == "validation_failed") {

			Swal.fire({
				color: '#012542',
				text: event.detail.apiResponse.message,
				icon: 'error',
				confirmButtonColor: '#012542',
				iconColor: '#CC67B5',
				confirmButtonText: 'Check errors',
			});

		} else {

			Swal.fire({
				color: '#012542',
				text: event.detail.apiResponse.message,
				icon: 'success',
				confirmButtonColor: '#012542',
				iconColor: '#209EAA',
			});

		}
	}, false);

})( jQuery );